import { useContext } from 'react';
import { CommerceContext } from '../../CommerceProvider';

export default function useCheckoutUpdate() {
    const { checkoutUpdate } = useContext(CommerceContext);
    return checkoutUpdate;
}
